export default "__VITE_ASSET__CYI0wxRu__"